// Design system scripted functionality.
require("@babel/polyfill");

(($) => {
    $('[data-toggle="tooltip"]').tooltip();

    $(".md-navbar-toggler").on("click", function (e) {
        $("a.nav-item-first-level").on("click", function (e) {
            var $parent = $(this).offsetParent("li.dropdown");
            $parent.siblings().addClass("hide");
            $parent.find("a.nav-item-first-level").addClass("hide");
            $(".md-helpNav").addClass("hide");
            $(".md-login-btn").addClass("hide");
        });
        $("p.nav-item-dropdown-header").on("click", function (e) {
            $(".navbar-collapse").find(".hide").removeClass("hide");
        });
        $(".navbar-collapse").find(".hide").removeClass("hide");
    });
    $(".dropdown-menu a").on("click", function (e) {
        var $parent = $("#tab-items");
        $parent.children().addClass("hide");
        $("#selected").text($(this).text());
        var selectedTab = $(this).attr("data-value");
        $parent.find(`#${selectedTab}`).removeClass("hide");
    });
    $(".dropdown-accordion").on(
        "click",
        'button[data-toggle="collapse"]',
        function (event) {
            event.preventDefault();
            event.stopPropagation();
            $($(this).data("target")).collapse("toggle");
        }
    );

    $("#btnCalcCost").on("click", function () {
        calcCost(document.theForm);
        $("#solarModalCenter").modal("show");
    });

    $("#resORcom0,#resORcom1").on("change", function () {
        setSysType(document.theForm);
    });

    $("#fedTaxCredit0,#fedTaxCredit1").on("change", function () {
        setFedFunds(document.theForm);
    });

    $(window).on("resize", function () {
        setMenuPosition();
    });

    $(setMenuPosition);

    $(setToggleIcons);

    $(".card-flip").on("click", function (e) {
        if (e.target.tagName !== "BUTTON") {
            if ($(this).hasClass("card-flip-all")) {
                $(this).siblings(".card-flip-all").toggleClass("flipped");
            }
            $(this).toggleClass("flipped");
        }
    });
    $("#gasCostPerGallon").on("keypresss", function(e){
        const key = e.which || e.keyCode;
        if (key >= 65 && key <= 90){
            e.preventDefault();
        } 
    });
    $("#gasCostPerGallon").on("keyup blur", function (e) {
        const el = $(this);
        const dollars = el.val().replace("$", "");
        const containsDot = dollars.indexOf(".") !== -1;
        const parts = dollars.split(".");
        parts[0] = Number(parts[0]) || 0;
        if (parts.length > 0) {
            parts[1] = parts[1] ? Number(parts[1]) : "";
        }
        el.val(
            `$${parts[0]}${containsDot ? "." : ""}${
                parts.length > 0 && parts[1] ? parts[1] : ""
            }`
        );
    });
    evSavingsCalculator();
})(jQuery); //Form functions

function evSavingsCalculator() {
    const range = $("#range");
    const gasCostPerGallon = $("#gasCostPerGallon");
    const vehicleMPG = $("#vehicleMPG");
    const inputMilesPerKWT = Number($("#milesPerKWT").val());
    const inputUtilituRatePerKWT = Number($("#utilituRatePerKWT").val());
    const inputAvgMaintenance = Number($("#avgMaintenance").val());

    const defatulMilesPerKWT = 3.5;
    const defatulUtilituRatePerKWT = 0.1117;
    const defaultAvgMaintenance = 0.04;

    const avgDaysInMonth = 30.43;

    const setValuesForEVCalc = () => {
        const milesPerKWT = inputMilesPerKWT ? inputMilesPerKWT : defatulMilesPerKWT;
        const utilituRatePerKWT = inputUtilituRatePerKWT ? inputUtilituRatePerKWT : defatulUtilituRatePerKWT;
        const avgMaintenance = inputAvgMaintenance ? inputAvgMaintenance : defaultAvgMaintenance;

        const monthly = $("#radioMonthly").is(":checked") ? avgDaysInMonth : 1;
        const avgMiles = Number(range.val());
        const avgMPG = Number(vehicleMPG.val());
        const avgGas = Number(gasCostPerGallon.val().replace('$',''));
        const calcGasCost =
            monthly * (avgMPG && avgGas ? (avgMiles / avgMPG) * avgGas : 0);
        const calcUtilityCost =
            monthly *
            ((avgMiles / milesPerKWT) * utilituRatePerKWT);
        const calcMaintenaceSavings = monthly * (avgMaintenance * avgMiles);
        $("#gasCost").html(calcGasCost ? `($${calcGasCost.toFixed(2)}` : "($0");
        $("#utilityCost").html(
            calcUtilityCost ? `$${calcUtilityCost.toFixed(2)}` : "$0"
        );
        $("#maintenaceSavings").html(
            calcMaintenaceSavings
                ? `$${calcMaintenaceSavings.toFixed(2)})`
                : "$0)"
        );
        $("#savings").html(
            calcGasCost && calcUtilityCost && calcMaintenaceSavings
                ? `$${((calcGasCost + calcMaintenaceSavings) - calcUtilityCost).toFixed(2)}`
                : "$0"
        );
    };

    const handleRangeInput = () => {
        const newValue = Number(
                ((range.val() - range.attr("min")) * 100) /
                    (range.attr("max") - range.attr("min"))
            ),
            newPosition = 16 - newValue * 0.32;
        $("#tooltip").html(`<span>${range.val()}</span>`);
        $("#tooltip").css({ left: `calc(${newValue}% + (${newPosition}px))` });
        $(":root").css(
            "--range-progress",
            `calc(${newValue}% + (${newPosition}px))`
        );
        setValuesForEVCalc();
    };

    const handleChange = () => {
        setValuesForEVCalc();
    };

    handleRangeInput();
    range.on("input", handleRangeInput);
    gasCostPerGallon.on("input", handleChange);
    vehicleMPG.on("input", handleChange);
    $("#btn-group :input").on("change", handleChange);
}

function setToggleIcons() {
    $("#toggleIconButton").click(function () {
        document.getElementById("toggleIconButton").style.backgroundColor =
            "transparent";
        document.getElementById("toggleIconButton2").style.backgroundColor =
            "transparent";
        if (
            document.getElementById("toggleIconChange").style.display == "none"
        ) {
            document.getElementById("toggleIconChange").style.display = "block";
            document.getElementById("toggleIconChange3").style.display = "none";
        } else {
            document.getElementById("toggleIconChange").style.display = "none";
            document.getElementById("toggleIconChange3").style.display =
                "block";
        }
    });
    $("#toggleIconButton2").click(function () {
        document.getElementById("toggleIconButton").style.backgroundColor =
            "transparent";
        document.getElementById("toggleIconButton2").style.backgroundColor =
            "transparent";
        if (
            document.getElementById("toggleIconChange2").style.display == "none"
        ) {
            document.getElementById("toggleIconChange2").style.display =
                "block";
            document.getElementById("toggleIconChange4").style.display = "none";
        } else {
            document.getElementById("toggleIconChange2").style.display = "none";
            document.getElementById("toggleIconChange4").style.display =
                "block";
        }
    });
}

function closeMobileNavigation() {
    const mobileMenu = document.getElementById("navbarNavDropdown");
    if (mobileMenu.classList.contains("show")) {
        mobileMenu.classList.remove("show");
        mobileMenu.classList.add("collapse");
    }
}

function setMenuPosition() {
    var position = $("#aboutUsDropdownMenuButton").position();

    if (position.left > 0) {
        $(".dropdown-menu-teco-pgs").attr(
            "style",
            "left:" + position.left + "px"
        );
    }

    if ($("#navbar-brand").length) {
        var brandPosition = $("#navbar-brand").position();
        $(".dropdown-menu-secondary").attr(
            "style",
            "left:" + brandPosition.left + "px"
        );
    }
}

//Form functions
function toggle(object, vis, dis) {
    if (document.getElementById) {
        document.getElementById(object).style.visibility = vis;
        document.getElementById(object).style.display = dis;
    } else if (document.layers && document.layers[object] != null) {
        document.layers[object].visibility = vis;
        document.layers[object].display = dis;
    } else if (document.all) {
        document.all[object].style.visibility = vis;
        document.all[object].style.display = dis;
    }

    return false;
}

function isRegExMatch(re, fieldOrStr, msg) {
    var valid = true;
    var InString = "";

    if (fieldOrStr.length != undefined) {
        InString = fieldOrStr;
    } else {
        InString = fieldOrStr.value;
    }

    valid = re.test(InString);

    // Alert and focus if a message is defined
    if (!valid && msg != undefined) {
        if (msg == "default") {
            alert("Please enter the value in the proper format.");
        } else {
            alert(msg);
        }
        fieldOrStr.focus();
    }
    return valid;
}

function addCommas(nStr) {
    nStr += "";
    x = nStr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
}

//Solar Calculation
function CurrencyFormatted(amount) {
    return "$" + addCommas(amount.toFixed(0));
}

var mthGenPerKW = 131.4;
var tecIncentivePerKW = 2000;
var tecIncentiveLimit = 20000;
var fedTxCredit = 0.3;
var costPerKW = 3000;
var roofSqFtPerKW = 100;
var nrgCost = 0.12;
var valueOfNrgGenPerYear = 0;

function setSysType(frmObj) {
    frmObj.custKW.value = frmObj.resORcom[0].checked ? 5 : 25;

    setNrgCost(frmObj);
    setTecFunds(frmObj);
    setFedFunds(frmObj);

    frmObj.custKW.select();
}

function setNrgCost(frmObj) {
    var doWhat = frmObj.resORcom[0].checked ? "res" : "com";

    if (doWhat == "res") {
        nrgCost = 0.12;
        toggle("estElectricCostCom", "hidden", "none");
        toggle("estElectricCostRes", "visible", "block");
    } else {
        nrgCost = 0.106;
        toggle("estElectricCostRes", "hidden", "none");
        toggle("estElectricCostCom", "visible", "block");
    }
}

function setTecFunds(frmObj) {
    if (frmObj.tecFundAvail[0].checked) {
        tecIncentiveLimit = 20000;
        toggle("noTecIncentive", "hidden", "none");
        toggle("tecIncentive", "visible", "block");
    } else {
        toggle("noTecIncentive", "visible", "block");
        toggle("tecIncentive", "hidden", "none");
    }
}

function setFedFunds(frmObj) {
    if (frmObj.fedTaxCredit[0].checked) {
        toggle("fedTaxCreditYes", "visible", "block");
        toggle("fedTaxCreditNo", "hidden", "none");
        fedTxCredit = 0.3;
    } else {
        toggle("fedTaxCreditNo", "visible", "block");
        toggle("fedTaxCreditYes", "hidden", "none");
        fedTxCredit = 0;
    }
}

function calcCost(frmObj) {
    var re = /^(\d)*((\.\d*)?)$/;
    var kW = 0;
    var tecIncentiveVar = 0;
    var fedIncentiveVar = 0;
    var sysCostVar = 0;
    var sysCostAfterTecIncentiveVar = 0;
    var totalCostVar = 0;
    var nrgGenVar = 0;
    var valueOfNrgGenPerMonthVar = 0;

    setNrgCost(frmObj);
    setFedFunds(frmObj);

    kW = parseFloat(frmObj.custKW.value);

    if (!isRegExMatch(re, frmObj.custKW.value) || kW != frmObj.custKW.value) {
        alert(
            "Size of solar panel installation in killowatts must be a numeric value."
        );
        frmObj.custKW.focus();
        return false;
    }

    document.getElementById("sysType").innerHTML =
        kW +
        "kW " +
        (frmObj.resORcom[0].checked ? "residential" : "small commercial") +
        " ";
    //alert(costPerKW);
    costPerKW = frmObj.pvCost.options[pvCost.selectedIndex].value;
    document.getElementById("pvCostPerKw").innerHTML =
        CurrencyFormatted(parseInt(costPerKW)) + " ";
    //set intial cost of system

    sysCostVar = kW * costPerKW;
    frmObj.sysCost.value = CurrencyFormatted(sysCostVar);

    fedIncentiveVar = sysCostVar * fedTxCredit;
    if (fedIncentiveVar > 0) {
        fedIncentive.value = CurrencyFormatted(fedIncentiveVar);
    } else {
        fedIncentive.value = "-";
    }

    //set total cost minus state and federal incentives
    totalCostVar = sysCostVar - tecIncentiveVar - fedIncentiveVar; //(sysCostVar - stIncentiveVar)
    totalCost.value = CurrencyFormatted(totalCostVar);

    //set roof space required
    roofSqFt.value = addCommas((kW * roofSqFtPerKW).toFixed(0));

    //calc amount of energy system will produce each month
    nrgGenVar = kW * mthGenPerKW;
    nrgGen.value = addCommas(nrgGenVar.toFixed(0));

    //calc amount of savings per month
    valueOfNrgGenPerMonthVar = nrgCost * nrgGenVar;
    valueOfNrgGenPerMonth.value = CurrencyFormatted(valueOfNrgGenPerMonthVar);

    //set amount of savings generated per year
    valueOfNrgGenPerYear = valueOfNrgGenPerMonthVar * 12;

    //set years to recover cost of solar installation
    yearsToRecover.value = (totalCostVar / valueOfNrgGenPerYear).toFixed(0);
}
